export default "__VITE_ASSET__PZXiX_v8__"